export default "__VITE_ASSET__$e2TXkZB__"